import React, { useEffect, useState } from 'react'
import './style.css'
import { sendEmail } from '../services/email'
import { Alert, Tooltip } from '@mui/material'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { reload } from '../icons'
import { numberWithCommas, valueLabelFormat } from '../utils/sliderFunctions'

const ComissionQuote = ({ price, dueDiligenceTimeline }) => {
  const [secure, setSecure] = useState(false)
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  var lvrPrice = 0.000780598 * price + 5714.73;
  var qoePrice = 0.00226749 * price + 8194.54;
  var qoeLitePrice = qoePrice * 0.75;
  var codebasePrice = 0.000780598 * price + 5714.73;
  var date = new Date()

  useEffect(() => {
    setTimeout(() => {
      setSecure(false)
    }, 3000)
  }, [secure])

  // Live Verification Report
  const quoteLVR = (price, dueDiligenceTimeline) => {
      if (
      dueDiligenceTimeline == '3-4 weeks' ||
      dueDiligenceTimeline == '4+ weeks'
    ) {
      // no expedite
      return `$${numberWithCommas(
        Math.floor((lvrPrice) / 100 + 0.5) * 100
      )}`
    } else if (dueDiligenceTimeline == '2 weeks') {
      // 2 weeks expedite
      return `$${numberWithCommas(
        Math.floor(((lvrPrice) * 1.1) / 100 + 0.5) * 100
      )}`
    } else if (dueDiligenceTimeline == '1 week') {
      // 1 week expedite
      return `$${numberWithCommas(
        Math.floor(((lvrPrice) * 1.15) / 100 + 0.5) * 100
      )}`
    }
  }

  const quoteQoE = (price, dueDiligenceTimeline) => {
      // Whenever formula exceeds $35K, we simply charge $35K
      if (qoePrice > 35000) {
            qoePrice = 35000;
      }
      if (
        dueDiligenceTimeline == '3-4 weeks' ||
        dueDiligenceTimeline == '4+ weeks'
      ) {
        // no expedite
        return `$${numberWithCommas(
          Math.floor((qoePrice) / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '2 weeks') {
        // 2 weeks expedite
        return `$${numberWithCommas(
          Math.floor(((qoePrice) * 1.1) / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '1 week') {
        // 1 week expedite
        return `$${numberWithCommas(
          Math.floor(((qoePrice) * 1.15) / 100 + 0.5) * 100
        )}`
      }
  }

    const quoteCodebase = (price, dueDiligenceTimeline) => {
        if (
          dueDiligenceTimeline == '3-4 weeks' ||
          dueDiligenceTimeline == '4+ weeks'
        ) {
          // no expedite
          return `$${numberWithCommas(
            Math.floor((codebasePrice) / 100 + 0.5) * 100
          )}`
        } else if (dueDiligenceTimeline == '2 weeks') {
          // 2 weeks expedite
          return `$${numberWithCommas(
            Math.floor(((codebasePrice) * 1.1) / 100 + 0.5) * 100
          )}`
        } else if (dueDiligenceTimeline == '1 week') {
          // 1 week expedite
          return `$${numberWithCommas(
            Math.floor(((codebasePrice) * 1.15) / 100 + 0.5) * 100
          )}`
        }
    }

  // LVR + QoE
  function quoteLVRQoE(price, dueDiligenceTimeline) {
     // Whenever formula exceeds $35K, we simply charge $35K
     if (qoePrice > 35000) {
        qoePrice = 35000;
     }
      if (
        dueDiligenceTimeline == '3-4 weeks' ||
        dueDiligenceTimeline == '4+ weeks'
      ) {
        // no expedite
        return `$${numberWithCommas(
            Math.floor((lvrPrice * 0.666666666 + qoePrice) / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '2 weeks') {
        // 2 weeks expedite
        return `$${numberWithCommas(
            Math.floor(((lvrPrice * 0.666666666 + qoePrice) * 1.1) / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '1 week') {
        // 1 week expedite
        return `$${numberWithCommas(
            Math.floor(((lvrPrice * 0.666666666 + qoePrice) * 1.15) / 100 + 0.5) * 100
        )}`
      }
  }

  function quoteQoELite(price, dueDiligenceTimeline) {
     // Whenever formula exceeds $28K, we simply charge $28K
     if (qoeLitePrice > 28000) {
        qoeLitePrice = 28000;
     }
      if (
        dueDiligenceTimeline == '3-4 weeks' ||
        dueDiligenceTimeline == '4+ weeks'
      ) {
        // no expedite
        return `$${numberWithCommas(
          Math.floor(qoeLitePrice / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '2 weeks') {
        // 2 weeks expedite
        return `$${numberWithCommas(
          Math.floor((qoeLitePrice * 1.1) / 100 + 0.5) * 100
        )}`
      } else if (dueDiligenceTimeline == '1 week') {
        // 1 week expedite
        return `$${numberWithCommas(
          Math.floor((qoeLitePrice * 1.15) / 100 + 0.5) * 100
        )}`
      }
  }

  return (
    <div className='comission-quote'>
      <h1>Your Instant Quote</h1>
      <p>
        {/* We believe in pricing transparency. Always know what you are playing. */}
      </p>
      <div className='comission-quote-prices'>
        <div>
          <h2>$750</h2>
          <p>
            <b>Preliminary Vetting</b>
          </p>
        </div>
        <div>
          <h2>{quoteLVR(price, dueDiligenceTimeline)}</h2>
          <p>
            <b>Live Verification Report (LVR)</b>
          </p>
        </div>
        <div>
          <h2>{quoteQoE(price, dueDiligenceTimeline)}</h2>
          <p>
            <b>Quality of Earnings (QoE)</b>
          </p>
        </div>
        <div>
          <h2>{quoteCodebase(price, dueDiligenceTimeline)}</h2>
          <p>
            <b>Codebase & Tech Stack Analysis</b>
          </p>
        </div>
        <div>
          <h2>{quoteLVRQoE(price, dueDiligenceTimeline)}</h2>
          <p>
            <b>Live Verification Report + Quality of Earnings</b>
          </p>
        </div>
        <div>
          <h2>{quoteQoELite(price, dueDiligenceTimeline)}</h2>
          <p>
            <b>Quality of Earnings "Lite"</b>
          </p>
        </div>
      </div>
      <div className='quote-footer'>
        {/* <Tooltip title='Secure this quote for 30 days.' placement='right'> */}
        <button className='quote_footer_button'>
          <a href='https://rapiddiligence.com/free-consultation' target='_blank'>
            Request a Free Consultation
          </a>
        </button>
        {/* </Tooltip> */}
        <p>Secure this quote for 30 days:</p>
        <div className='form_container'>
          <TextField
            id='outlined-basic'
            label='First Name'
            variant='outlined'
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            id='outlined-basic'
            label='Email'
            variant='outlined'
            onChange={(e) => setEmail(e.target.value)}
          />
          <Button
            variant='contained'
            onClick={() => {
              sendEmail({
                to: email,
                to_name: name,
                quotes: `Preliminary Vetting: $750, 
                
                Live Verification Report (LVR): ${quoteLVR(
                  price,
                  dueDiligenceTimeline
                )}, 
                
                Quality of Earnings (QoE): ${quoteQoE(
                  price,
                  dueDiligenceTimeline
                )}, 
                
                Codebase & Tech Stack Analysis: ${quoteCodebase(
                  price,
                  dueDiligenceTimeline
                )}, 
                
                Live Verification Report + Quality of Earnings: ${quoteLVRQoE(
                  price,
                  dueDiligenceTimeline
                )}, 
                
                Quality of Earnings "Lite": ${quoteQoELite(
                  price,
                  dueDiligenceTimeline
                )}`,
                price: `${valueLabelFormat(price)}`,
                timeline: dueDiligenceTimeline,
                date: new Date(
                  date.setDate(date.getDate() + 30)
                ).toDateString(),
                setSecure: setSecure,
              })
            }}
          >
            Secure
          </Button>
          {secure ? (
            <Alert severity='success'>
              Your quote is secured and ready for you in your inbox!
            </Alert>
          ) : (
            ''
          )}
        </div>
        <p className='generate-quote'>
          <a href=''>Generate Another Quote </a>
          {reload}
        </p>
      </div>
    </div>
  )
}

export default ComissionQuote
